export default __webpack_public_path__ + "static/join01-f1bfce0df654d572b0ec1b1482efd63e.png";